export default __webpack_public_path__ + "static/media/brokerStepIcon1.dc5daf2e.webp";